function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) {
    var e, n, i, u, a = [], f = !0, o = !1;
    try {
        if (i = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t)
                return;
            f = !1;
        }
        else
            for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0)
                ;
    }
    catch (r) {
        o = !0, n = r;
    }
    finally {
        try {
            if (!f && null != t.return && (u = t.return(), Object(u) !== u))
                return;
        }
        finally {
            if (o)
                throw n;
        }
    }
    return a;
} }
function _arrayWithHoles(r) { if (Array.isArray(r))
    return r; }
import React, { useState } from 'react';
import { Line } from 'react-chartjs-2';
import { Chart as ChartJS, LineElement, PointElement, LinearScale, CategoryScale, Tooltip, Legend, Filler } from 'chart.js';
import { Dropdown, Button } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import { useQuery } from '@tanstack/react-query';
import { fetchMonthlyActivity, fetchYearlyActivity } from '../../../cores/api/api-dashboard';
import { buildDauMauChartData, DEFAULT_MONTHLY_CHART } from '../../../utils/common-chart';
ChartJS.register(LineElement, PointElement, LinearScale, CategoryScale, Tooltip, Legend, Filler);
const monthData = {
    labels: Array.from({
        length: 12
    }, (_, i) => `${i + 1}月`),
    datasets: [{
            label: 'ユーザー数',
            data: [1, 6, 7, 23, 10, 11, 2, 3, 9, 8, 8, 10],
            fill: true,
            tension: 0.4,
            backgroundColor: 'rgba(107, 138, 253, 0.1)',
            borderColor: '#6b8afd',
            pointBackgroundColor: '#6b8afd'
        }]
};
const yearData = {
    labels: Array.from({
        length: 31
    }, (_, i) => `2025/07/${(i + 1).toString().padStart(2, '0')}`),
    datasets: [{
            label: 'ユーザー数',
            data: Array.from({
                length: 31
            }, () => Math.floor(Math.random() * 10)),
            fill: true,
            tension: 0.3,
            backgroundColor: 'rgba(107, 138, 253, 0.1)',
            borderColor: '#6b8afd',
            pointBackgroundColor: '#6b8afd'
        }]
};
const chartOptions = {
    responsive: true,
    plugins: {
        legend: {
            display: false
        }
    },
    scales: {
        y: {
            beginAtZero: true
        }
    }
};
const periodOptions = [{
        key: 'monthly',
        label: '月別'
    }, {
        key: 'yearly',
        label: '年別'
    }];
export default function SectionDauMauChart() {
    var _a;
    const year = new Date().getFullYear();
    const month = new Date().getMonth() + 1;
    const _useState = useState('monthly'), _useState2 = _slicedToArray(_useState, 2), selectedPeriod = _useState2[0], setSelectedPeriod = _useState2[1];
    const _useQuery = useQuery({
        queryKey: ['activity', selectedPeriod, year, month],
        queryFn: () => selectedPeriod === 'monthly' ? fetchMonthlyActivity({
            year,
            month
        }) : fetchYearlyActivity({
            year
        }),
        suspense: true,
        placeholderData: {
            data: {
                '1月': 0,
                '2月': 0,
                '3月': 0,
                '4月': 0,
                '5月': 0,
                '6月': 0,
                '7月': 0,
                '8月': 0,
                '9月': 0,
                '10月': 0,
                '11月': 0,
                '12月': 0
            },
            status: 200
        }
    }), data = _useQuery.data;
    const chartData = React.useMemo(() => {
        if (!(data === null || data === void 0 ? void 0 : data.data))
            return DEFAULT_MONTHLY_CHART;
        return buildDauMauChartData(data.data);
    }, [data]);
    const handleMenuClick = ({ key }) => {
        setSelectedPeriod(key);
    };
    const items = periodOptions;
    const selectedLabel = (_a = periodOptions.find(o => o.key === selectedPeriod)) === null || _a === void 0 ? void 0 : _a.label;
    return /*#__PURE__*/ React.createElement("div", {
        className: "bg-white"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex w-full justify-end items-center mb-4"
    }, /*#__PURE__*/ React.createElement(Dropdown, {
        menu: {
            items,
            onClick: handleMenuClick
        }
    }, /*#__PURE__*/ React.createElement(Button, {
        className: "!border-none !shadow-none text-gray-800"
    }, selectedLabel, " ", /*#__PURE__*/ React.createElement(DownOutlined, null)))), /*#__PURE__*/ React.createElement(Line, {
        data: chartData,
        options: chartOptions,
        height: 100
    }));
}
